var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-info"},[_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"icon"},[_c('FontAwesomeIcon',{attrs:{"icon":_vm.icon}})],1)]),_c('p',{staticClass:"info-text"},[_vm._v(_vm._s(_vm.info))])])}
var staticRenderFns = []

export { render, staticRenderFns }